import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { CalendarToday, FiberManualRecord } from '@material-ui/icons';
import { orange } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
  newNotificationFadeOut: {
    color: orange[500],
    marginTop: '-10px',
    opacity: 0,
    transition: 'opacity 1s',
  },
  newNotificationFadeIn: {
    color: orange[500],
    marginTop: '-10px',
    opacity: 1,
    transition: 'opacity 1s',
  },
  elementColors: {
    color: theme.palette.type === 'dark' ? '#E9E9E9' : '#494949',
  },
  calendarIconStyle: {
    fontSize: '14px',
    color: theme.palette.type === 'dark' ? '#E9E9E9' : '#45505E',
  },
  notificationDateStyle: {
    fontWeight: 400,
    fontSize: '8px',
    lineHeight: '10.64px',
    color: theme.palette.type === 'dark' ? '#BA68C8' : '#9C27B0',
  },
  calendarIconStyleSelected: {
    fontSize: '14px',
    color: theme.palette.type === 'dark' ? '#5E176A' : '#45505E',
  },
  selectedColor: {
    color: '#5E176A',
  },
  notificationDateStyleSelected: {
    fontWeight: 400,
    fontSize: '8px',
    lineHeight: '10.64px',
    color: '#9C27B0',
  },
}));

const NotificationEvents = props => {
  const { eventData, selected } = props;
  const classes = useStyles();
  return (
    <>
      <Grid container style={{ margin: '5px 0px 5px 5px' }}>
        <Grid item xs={12}>
          <Grid container direction="row" alignItems="center">
            <Grid item>
              <CalendarToday className={selected ? classes.calendarIconStyleSelected : classes.calendarIconStyle} />
            </Grid>
            <Grid item style={{ marginLeft: '5px', maxWidth: '100px' }}>
              <Typography
                className={selected ? classes.selectedColor : classes.elementColors}
                style={{ fontWeight: 'bold', fontSize: '14px', lineHeight: '15.96px' }}
              >
                {eventData.eventName}
              </Typography>
            </Grid>
            <Grid item style={{ marginLeft: '5px' }}>
              <Typography
                className={selected ? classes.selectedColor : classes.elementColors}
                style={{ fontWeight: 400, fontSize: '12px', lineHeight: '15.96px' }}
              >
                {`(${eventData.eventDate})`}
              </Typography>
            </Grid>

            <Grid item style={{ marginRight: '12px' }}>
              <FiberManualRecord
                className={eventData.isRead ? classes.newNotificationFadeOut : classes.newNotificationFadeIn}
                style={{ fontSize: '10px' }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ marginLeft: '17px' }}>
          <Typography
            className={selected ? classes.selectedColor : classes.elementColors}
            style={{ fontWeight: 400, fontSize: '12px', lineHeight: '15.96px' }}
          >
            {eventData.type}
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ marginLeft: '17px' }}>
          <Typography
            className={selected ? classes.selectedColor : classes.elementColors}
            style={{ fontWeight: 400, fontSize: '14px', lineHeight: '18.62px' }}
          >
            {eventData.groupName}
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ marginLeft: '17px' }}>
          <Typography
            className={selected ? classes.selectedColor : classes.elementColors}
            style={{ fontWeight: 400, fontSize: '10px', lineHeight: '13.3px' }}
          >
            {`Org: ${eventData.org}`}
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ marginLeft: '17px', marginTop: '5px' }}>
          <Typography className={selected ? classes.notificationDateStyleSelected : classes.notificationDateStyle}>
            {eventData.datetime}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

NotificationEvents.propTypes = {
  eventData: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default NotificationEvents;
